const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    const number = Number(String(value).replace(",", "."));

    return Number.isFinite(number) ? number : 0;
};

const getPesoProducto = (producto) => {
    return toNumber(producto.peso);
};

const calcularPesoTotal = (productos = []) => {
    return productos.reduce((total, producto) => {
        return total + getPesoProducto(producto);
    }, 0);
};

const prepararVehiculos = (vehiculos = []) => {
    return vehiculos
        .map((vehiculo) => ({
            ...vehiculo,
            pesoMaximo: toNumber(vehiculo.peso),
            usado: false
        }))
        .filter((vehiculo) => vehiculo.pesoMaximo > 0);
};

const generarSiguienteNumeroDocumento = (numeroDocumentoActual) => {
    return `${numeroDocumentoActual}-1`;
};

const buscarVehiculoParaProducto = ({
    vehiculos,
    pesoProducto,
    usarVehiculoSoloUnaVez
}) => {
    return vehiculos
        .filter((vehiculo) => {
            if (usarVehiculoSoloUnaVez && vehiculo.usado) return false;

            return vehiculo.pesoMaximo >= pesoProducto;
        })
        .sort((a, b) => b.pesoMaximo - a.pesoMaximo)[0] || null;
};

const crearEntregaAsignada = ({
    numeroDocumento,
    documentoOriginal,
    productos,
    vehiculo
}) => {
    const productosActualizados = productos.map((producto) => ({
        ...producto,
        numeroDocumento
    }));

    return {
        numeroDocumento,
        numeroDocumentoOriginal: documentoOriginal.numeroDocumentoOriginal,
        pesoTotal: calcularPesoTotal(productosActualizados),
        productos: productosActualizados,
        vehiculoAsignado: {
            id: vehiculo.id,
            placa: vehiculo.labelPlaca,
            conductor: vehiculo.nombreConductor,
            pesoMaximo: vehiculo.pesoMaximo
        }
    };
};

const dividirDocumentoPorPeso = ({
    numeroDocumento,
    documento,
    vehiculos,
    usarVehiculoSoloUnaVez = false
}) => {
    let numeroDocumentoActual = String(numeroDocumento);

    const productosPendientes = [...documento.productos].sort((a, b) => {
        return getPesoProducto(b) - getPesoProducto(a);
    });

    const asignadas = {};
    const noAsignadas = {};

    while (productosPendientes.length > 0) {
        const productoMasPesado = productosPendientes[0];
        const pesoProductoMasPesado = getPesoProducto(productoMasPesado);

        const vehiculo = buscarVehiculoParaProducto({
            vehiculos,
            pesoProducto: pesoProductoMasPesado,
            usarVehiculoSoloUnaVez
        });

        if (!vehiculo) {
            noAsignadas[numeroDocumentoActual] = {
                pesoTotal: calcularPesoTotal(productosPendientes),
                productos: productosPendientes,
                motivo: `No hay vehículo disponible para cargar el producto más pesado: ${pesoProductoMasPesado}`
            };

            break;
        }

        let pesoDisponible = vehiculo.pesoMaximo;
        const productosParaEsteVehiculo = [];

        for (let i = productosPendientes.length - 1; i >= 0; i--) {
            const producto = productosPendientes[i];
            const pesoProducto = getPesoProducto(producto);

            if (pesoProducto <= pesoDisponible) {
                productosParaEsteVehiculo.push(producto);
                pesoDisponible -= pesoProducto;
                productosPendientes.splice(i, 1);
            }
        }

        asignadas[numeroDocumentoActual] = crearEntregaAsignada({
            numeroDocumento: numeroDocumentoActual,
            documentoOriginal: {
                ...documento,
                numeroDocumentoOriginal: String(numeroDocumento)
            },
            productos: productosParaEsteVehiculo,
            vehiculo
        });

        vehiculo.usado = true;

        if (productosPendientes.length > 0) {
            numeroDocumentoActual = generarSiguienteNumeroDocumento(numeroDocumentoActual);
        }
    }

    return {
        asignadas,
        noAsignadas
    };
};

export const sharedDividirNoAsignadasPorPeso = ({
    noAsignadas = {},
    vehiculos = [],
    usarVehiculoSoloUnaVez = false
}) => {
    const vehiculosPreparados = prepararVehiculos(vehiculos);

    const nuevasAsignadas = {};
    const siguenNoAsignadas = {};

    for (const [numeroDocumento, documento] of Object.entries(noAsignadas)) {
        const resultado = dividirDocumentoPorPeso({
            numeroDocumento,
            documento,
            vehiculos: vehiculosPreparados,
            usarVehiculoSoloUnaVez
        });

        Object.assign(nuevasAsignadas, resultado.asignadas);
        Object.assign(siguenNoAsignadas, resultado.noAsignadas);
    }

    return {
        asignadas: nuevasAsignadas,
        noAsignadas: siguenNoAsignadas,
        vehiculos: vehiculosPreparados
    };
};